import { EWidgets } from "@/features/financas/views/Indicadores/@types/enums";
import { TLocalShortcuts } from "@/features/financas/views/Indicadores/store/dashboard/types";
import {
  EFieldsName,
  IDataPreference
} from "@/features/financas/views/Indicadores/@types/type";
import Preferencia from "./Preferencia";
import { inject, injectable } from "inversify";
import { DITypes } from "@/core/@types/types";
import { type IF360Date } from "@/core/plugins/date/F360Date";
import { type IToastNotification } from "@/composables/shared/notification/types";

interface NameShortcutPeriodoStrategy {
  [key: number]: EFieldsName;
}

@injectable()
export default class CreateCustomShortCut {
  @inject(DITypes.DATE) private libDate!: IF360Date;

  @inject(DITypes.NOTIFICATION)
  private notification!: IToastNotification<string>;

  handleShortcutPersonalizado(
    values: TLocalShortcuts,
    id: number,
    displayName: string
  ): IDataPreference[] {
    const limitDaysRange = id == EWidgets.VendasPanel ? 365 : 90;
    const millisecondsInADay = 86400000;

    const limitRange =
      this.libDate.getDiff(values.range.start, values.range.end) /
      millisecondsInADay;

    if (limitRange > limitDaysRange) {
      this.notification.showNotification(
        `Não é possível salvar um período maior que ${limitDaysRange} dias nas preferências. Manteremos salvo os demais filtros.`,
        { type: "info", timeout: 5000 }
      );

      return [];
    }

    const nameShortcutPeriodoStrategyInicio: NameShortcutPeriodoStrategy = {
      [EWidgets.VendasPanel]: EFieldsName.vendasShortcutPeriodoInicio,
      [EWidgets.FluxoCaixaPainel]: EFieldsName.fluxoShortcutPeriodoInicio,
      [EWidgets.DesempenhoVendas]: EFieldsName.desempenhoDeVendasPeriodoInicio
    };

    const fieldNameCustomInicio = nameShortcutPeriodoStrategyInicio[id];

    const nameShortcutPeriodoStrategyFim: NameShortcutPeriodoStrategy = {
      [EWidgets.VendasPanel]: EFieldsName.vendasShortcutPeriodoFim,
      [EWidgets.FluxoCaixaPainel]: EFieldsName.fluxoShortcutPeriodoFim,
      [EWidgets.DesempenhoVendas]: EFieldsName.desempenhoDeVendasPeriodoFim
    };

    const fieldNameCustomFim = nameShortcutPeriodoStrategyFim[id];

    const shortcutPeriodoInicio = new Preferencia({
      fieldName: fieldNameCustomInicio,
      fieldData: values.range.start,
      displayName: displayName,
      id: id
    }).createPreferencesData();
    const shortcutPeriodoFim = new Preferencia({
      fieldName: fieldNameCustomFim,
      fieldData: values.range.end,
      displayName: displayName,
      id: id
    }).createPreferencesData();

    return [shortcutPeriodoInicio, shortcutPeriodoFim];
  }
}
